import React from "react";
import { FaEllipsisV } from "react-icons/fa";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/OurService.css";
import TestimonialSection from "./TestimonialSection";

const links = [
  {
    title: "Insect Mosquito Protection",
    url: "/mosquito",
    image: "/assets/mosquitonet.webp"
  },
  {
    title: "Interior Design And Fernitures",
    url: "/interior",
    image: "/assets/interiordesign.webp"
  },
  {
    title: "Pest Control Services",
    url: "/pest-control",
    image: "/assets/pestcontrol.webp"
  },
  {
    title: "House Keeping Service",
    url: "/housekeeping",
    image: "/assets/housekeeping.webp"
  },
  {
    title: "Security Guard Service",
    url: "/security",
    image: "/assets/security.webp"
  },
];

export default function OurService() {
  return (
    <>
      <div className="linktree-wrapper bg-dark text-light text-center py-5 px-3">
        <h2 className="mb-4 ourservice-text d-none d-md-block" data-aos="fade-up">Our Services</h2>

        <div className="container">
          <div className="row justify-content-center">
            {links.map((link, index) => (
              <div
                className="col-12 col-md-4 mb-4"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                {/* === Desktop View === */}
                <div className="desktop-card d-none d-lg-flex flex-column h-100">
                  <img
                    src={link.image}
                    alt={link.title}
                    className="img-fluid desktop-card-img"
                  />
                  <div className="desktop-card-body d-flex flex-column justify-content-between text-center p-3">
                    <Link to={link.url} className="text-decoration-none">
                      <h5 className="fw-bold text-white link-title">{link.title}</h5>
                    </Link>
                  </div>
                </div>

                {/* === Mobile View === */}
                <Link
                  to={link.url}
                  className="text-decoration-none d-lg-none"
                  style={{ color: "inherit", display: "block" }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center py-3 px-4 rounded-3 linktree-card"
                    data-aos="fade-up"
                  >
                    <div className="fw-semibold text-start">{link.title}</div>
                    <FaEllipsisV style={{ color: "#7d7d7d" }} />
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      <TestimonialSection />
    </>
  );
}
